(() => {
  if (customElements.get('rfq72-product')) return;
  const storageKey = 'fdc.rfq.catalog.v1';
  const clean = value => String(value || '').trim();
  const key = item => clean(item.sku || item.variantId || item.url || item.description).toLowerCase();
  class Rfq72Product extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-rfq72-product]').textContent);
      this.button = this.querySelector('.rfq72-product__button');
      this.status = this.querySelector('.rfq72-product__status');
      this.form = document.getElementById(this.dataset.formId);
      this.update = this.update.bind(this);
      this.scope = this.closest('.product__info') || this.closest('.product-form') || this.parentElement;
      this.scope.addEventListener('change', this.update);
      this.scope.addEventListener('input', this.update);
      this.form?.addEventListener('variant:changed', this.update);
      this.onAdd = this.onAdd || this.add.bind(this);
      this.button.addEventListener('click', this.onAdd);
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.update);
      this.scope?.removeEventListener('input', this.update);
      this.form?.removeEventListener('variant:changed', this.update);
      this.button?.removeEventListener('click', this.onAdd);
      this.initialized = false;
    }
    selected() {
      this.form = document.getElementById(this.dataset.formId);
      const id = this.form?.elements.namedItem('id')?.value;
      return this.data.variants.find(variant => String(variant.id) === String(id));
    }
    item() {
      const variant = this.selected();
      if (!variant) return null;
      const quantityInput = this.form?.elements.namedItem('quantity');
      const quantity = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
      const url = new URL(this.data.url, location.origin);
      url.searchParams.set('variant', String(variant.id));
      const item = {itemType:'catalogue',description:this.data.title,productId:String(this.data.id),variantId:String(variant.id),quantity:String(quantity),sku:variant.sku || '',url:url.pathname + url.search};
      const configuration = [];
      this.data.options.forEach((option, index) => {
        const name = typeof option === 'object' ? option.name : option;
        const value = variant.options[index];
        if (!value || value === 'Default Title') return;
        if (/colou?r|couleur/i.test(name)) item.colour = value;
        else if (/size|taille|grandeur/i.test(name)) item.size = value;
        else configuration.push(name + ': ' + value);
      });
      if (configuration.length) item.configuration = configuration.join('; ');
      return item;
    }
    update() {
      const item = this.item();
      this.toggleAttribute('data-unavailable', !item);
      this.button.setAttribute('aria-disabled', String(!item));
      if (!item) return;
      const url = new URL(this.dataset.portal, location.origin);
      url.searchParams.set('rfq_product', item.description);
      url.searchParams.set('rfq_sku', item.sku);
      url.searchParams.set('rfq_quantity', item.quantity);
      url.searchParams.set('rfq_url', item.url);
      if (item.productId) url.searchParams.set('rfq_product_id', item.productId);
      if (item.variantId) url.searchParams.set('rfq_variant_id', item.variantId);
      if (item.colour) url.searchParams.set('rfq_color', item.colour);
      if (item.size) url.searchParams.set('rfq_size', item.size);
      if (item.configuration) url.searchParams.set('rfq_configuration', item.configuration);
      url.hash = 'rfq-form';
      this.button.href = url.href;
    }
    add(event) {
      this.update();
      const item = this.item();
      if (!item) {
        event.preventDefault();
        this.status.textContent = this.dataset.select;
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      try {
        let items = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(items)) items = [];
        items = items.filter(value => value && typeof value === 'object');
        const index = items.findIndex(value => key(value) === key(item));
        const count = items.filter(value => value.itemType === 'catalogue' || value.productId || value.variantId || value.url).length;
        event.preventDefault();
        if (index < 0 && count >= 5) {
          this.setAttribute('data-limit-reached', '');
          this.status.textContent = this.dataset.limit;
          return;
        }
        if (index < 0) items.push(item);
        else items[index] = {...items[index],...item,quantity:String((Number(items[index].quantity) || 0) + Number(item.quantity))};
        sessionStorage.setItem(storageKey, JSON.stringify(items));
        this.removeAttribute('data-limit-reached');
        const total = items.filter(value => value.itemType === 'catalogue' || value.productId || value.variantId || value.url).length;
        this.status.textContent = this.dataset.added.replace('[count]', String(total));
      } catch (error) {
        location.assign(this.button.href);
      }
    }
  }
  customElements.define('rfq72-product', Rfq72Product);
})();
